import getUrl from './getUrl.js';

export default function shippingInstructions(idShipping) {
    return fetch(`${getUrl()}/v2/shipping/instructions/${idShipping}`, {
      method: 'GET',
      headers: {
        'Content-type':'application/json'
      },
      credentials: 'include',
    })
    .then(res => res.json())
}